import React from 'react';

const RecruitmentBenefitsNews = React.lazy(() => import('pages/RecruitmentBenefitsNews/RecruitmentBenefitsNews'));
const RecruitmentBenefitsNewsAdd = React.lazy(() => import('pages/RecruitmentBenefitsNews/RecruitmentBenefitsNewsAdd'));
const RecruitmentBenefitsNewsEdit = React.lazy(() =>
  import('pages/RecruitmentBenefitsNews/RecruitmentBenefitsNewsEdit'),
);
const RecruitmentBenefitsNewsDetail = React.lazy(() =>
  import('pages/RecruitmentBenefitsNews/RecruitmentBenefitsNewsDetail'),
);

const recruitmentBenefitsNewsRoutes = [
  {
    path: '/recruitment-benefits-news',
    exact: true,
    name: 'Danh sách quyền lợi',
    function: 'RECRUITMENT_BENEFITS_NEWS_VIEW',
    component: RecruitmentBenefitsNews,
  },
  {
    path: '/recruitment-benefits-news/add',
    exact: true,
    name: 'Thêm mới quyền lợi',
    function: 'RECRUITMENT_BENEFITS_NEWS_ADD',
    component: RecruitmentBenefitsNewsAdd,
  },
  {
    path: '/recruitment-benefits-news/detail/:id',
    exact: true,
    name: 'Chi tiết quyền lợi',
    function: 'RECRUITMENT_BENEFITS_NEWS_VIEW',
    component: RecruitmentBenefitsNewsDetail,
  },
  {
    path: '/recruitment-benefits-news/edit/:id',
    exact: true,
    name: 'Chỉnh sửa quyền lợi',
    function: 'RECRUITMENT_BENEFITS_NEWS_EDIT',
    component: RecruitmentBenefitsNewsEdit,
  },
];

export default recruitmentBenefitsNewsRoutes;
